import { EventEmitter, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable, of, throwError } from 'rxjs';
import { SnackbarService } from './snackbar.service';
import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { ServerResponse } from '../../interfaces/base/server.response';
import { catchError, map } from 'rxjs/operators';
import { ServerRouteProperties } from '../../interfaces/base/server-route-properties';
import { Router, UrlSerializer, UrlTree } from '@angular/router';
import * as _ from 'lodash';

@Injectable()

export class ApiService {

  public generalHttpError: EventEmitter<boolean> = new EventEmitter<boolean>(false);

  private queryString: string = '';

  public routeParams: ServerRouteProperties = {
    filters: [],
  };

  constructor(private http: HttpClient,
              private snackbarService: SnackbarService,
              private router: Router,
              private serializer: UrlSerializer,
  ) {
  }

  get isOnline(): boolean {
    return !!window.navigator.onLine;
  }

  get(
    url: string,
    urlData?: ServerRouteProperties,
  ): Observable<ServerResponse> {
    return this.http.get(environment.api_endpoint + url + this.buildGetUrl(urlData), {
      observe: 'response',
      responseType: 'json',
    })
      .pipe(
        map((response: HttpResponse<ServerResponse>) => this.handleResponse(response)),
        catchError((error: HttpErrorResponse) => this.handleErrorResponse(error))
      );
  }

  post(url: string, formData?: any): Observable<ServerResponse> {
    return this.http.post(environment.api_endpoint + url, (formData ? formData : null), {
      observe: 'response',
      responseType: 'json',
    })
      .pipe(
        map((response: HttpResponse<ServerResponse>) => this.handleResponse(response)),
        catchError((error: HttpErrorResponse) => this.handleErrorResponse(error))
      );
  }

  buildGetUrl(urlData: ServerRouteProperties): string {
    this.queryString = '';
    const filters = this.routeParams.filters,
      routeParams: ServerRouteProperties = {
        filters: []
      };

    delete routeParams.filters;

    if (typeof urlData !== 'undefined') {
      if (urlData !== null) {
        for (const key in urlData) {
          if (urlData.hasOwnProperty(key)) {
            routeParams[key] = urlData[key];
          }
        }
      }
    }

    const tree: UrlTree = this.router.createUrlTree([''], {queryParams: routeParams});
    this.queryString = this.serializer.serialize(tree).substring(1);

    return this.queryString;
  }

  handleResponse(res: HttpResponse<ServerResponse>): ServerResponse {
    this.generalHttpError.next(false);
    if (typeof res.body !== 'undefined') {
      if (typeof res.body.message !== 'undefined') {
        this.snackbarService.success(res.body.message);
      }

      return res.body;
    }
  }

  handleErrorResponse(error: HttpErrorResponse): Observable<ServerResponse> {
    this.generalHttpError.next(true);

    if (typeof error.error !== 'undefined' && error.error !== null && typeof error.error.message !== 'undefined') {
      this.snackbarService.error(error.error.message);
    } else {
      this.snackbarService.error('Er is een fout opgetreden tijdens het laden van de data, probeer het nogmaals.');
    }

    throwError(error.error);

    return of({
      status: 500,
      error: error.error
    });
  }

  isErrorResponse(response: ServerResponse): boolean {
    return !(typeof response.errors === 'undefined' && typeof response.exception === 'undefined' && response.status !== 500 && response.status !== 400);
  }

  setFilter(field: string, value: string | number): void {
    const index: number = _.findIndex(this.routeParams.filters, data => data.field === field);

    if (index !== -1) {
      this.routeParams.filters[index] = {
        field: field,
        value: value
      };
    } else {
      this.routeParams.filters.push({
        field: field,
        value: value
      });
    }
  }

  clearFilter(field: string = null): void {
    if (field !== null) {
      const index: number = _.findIndex(this.routeParams.filters, data => data.field === field);

      if (index !== -1) {
        this.routeParams.filters.splice(index, 1);
      }
    } else {
      this.routeParams.filters = [];
    }
  }
}
